import { Injectable, Inject } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Sgkc010aRequest, Sgkc010aResponse, SGKC010AService } from 'sg-api';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

/**
 * 単価表承認API使用サービス
 * @export
 * @class UsedSgkc010aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc010aService {
    /**
       * コンストラクタ
       * @param {SGKC010AService} sGKC010AService
       * @param {ApiCommonService} apiCommonService
       * @param {FeaturesLibConfig} featuresLibConfig
       * @memberof UsedSgkc010aService
       */
    constructor(private sGKC010AService: SGKC010AService,
        private apiCommonService: ApiCommonService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

    /**
     * 単価表承認API呼び出し
     * @param {Sgkc010aRequest} sgkc010aRequest
     * @return {Observable<Sgkc010aResponse>}
     * @memberof UsedSgkc010aService
     */
    approveTankatable(sgkc010aRequest: Sgkc010aRequest): Observable<Sgkc010aResponse> {
        return this.sGKC010AService.kC10WSGKC010APost(<Sgkc010aRequest>this.apiCommonService.setRequestCommon(sgkc010aRequest), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    return response.body;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC010A');
                    return throwError(err.message);
                })
            );
    }

}
